"use client";

import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import Container from "@/components/ui/container";

const ErrorBoundry = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useEffect(() => {
    console.error("Uygulama hatası:", error);
  }, [error]);

  return (
    <Container>
      <div className="flex flex-col items-center justify-center py-20 gap-4 text-center">
        <h2 className="text-2xl font-bold text-gray-900">Bir hata oluştu!</h2>
        <p className="text-gray-600 max-w-md">{error.message || "Beklenmeyen bir hata meydana geldi."}</p>
        <Button onClick={() => reset()}>Tekrar Dene</Button>
      </div>
    </Container>
  );
};

export default ErrorBoundry;
